import React from "react";
import { Button } from "react-bootstrap";

export default function EventPagination({ page, count, next, previous, loading, onPageChange }) {
    if (!count && page === 1) return null;
    return (
        <nav aria-label="Event-Seiten" className="d-flex flex-wrap align-items-center justify-content-center gap-3 my-3">
            <Button variant="outline-secondary" disabled={loading || !previous} onClick={() => onPageChange(page - 1)}>
                Zurück
            </Button>
            <span aria-live="polite">Seite {page} · {count} Events</span>
            <Button variant="outline-secondary" disabled={loading || !next} onClick={() => onPageChange(page + 1)}>
                Weiter
            </Button>
        </nav>
    );
}
